import { render, staticRenderFns } from "./EcommerceProductTableCell.vue?vue&type=template&id=08ac3cc8&"
import script from "./EcommerceProductTableCell.vue?vue&type=script&lang=js&"
export * from "./EcommerceProductTableCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports